import { AppBar, Grid, Link, Toolbar } from "@material-ui/core";
import React from "react";

import binaryLogo from "../../assets/binary_logo.png";
import ElevationScroll from "../shared/Elevation";
import useStyle from "./header.style";
import HeaderNavbar from "./HeaderNavbar";

function Header(props) {
  const classes = useStyle();
  return (
    <>
      <Toolbar id="back-to-top-anchor" />
      <ElevationScroll>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <Grid container spacing={4}>
              <Grid item xs={6} style={{ margin: "auto" }}>
                <Link href="/">
                  <img
                    src={binaryLogo}
                    style={{ width: 150, height: 40 }}
                    alt="binary_logo"
                  />
                </Link>
              </Grid>
              <Grid item xs={6} className={classes.alignGridItems}>
                <HeaderNavbar />
              </Grid>
            </Grid>
          </Toolbar>
        </AppBar>
      </ElevationScroll>
    </>
  );
}

export default React.memo(Header);
